export default "__VITE_ASSET__bc3c2379__"